import { render } from "./PedidoCompraImpostos.vue?vue&type=template&id=508ef010&scoped=true&ts=true"
import script from "./PedidoCompraImpostos.vue?vue&type=script&lang=ts"
export * from "./PedidoCompraImpostos.vue?vue&type=script&lang=ts"

import "./PedidoCompraImpostos.vue?vue&type=style&index=0&id=508ef010&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508ef010"]])

export default __exports__